import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/api";
import { useVisitor } from "@/lib/visitor";
import { readContact } from "@/lib/journey";

export const ContactDialog = ({ open, title, description, submitLabel, onSubmit, onClose, children, testId }) => {
  const { profile } = useVisitor();
  const [f, setF] = useState({ name: "", mobile: "", email: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) { const c = readContact(); setF({ name: c?.name || profile?.nickname || "", mobile: c?.mobile || profile?.mobile || "", email: c?.email || profile?.email || "" }); }
  }, [open, profile]);
  const submit = async (e) => {
    e.preventDefault();
    if (!f.name.trim() || f.mobile.trim().length < 7) return toast.error("Please share your name and mobile number.");
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email.trim())) return toast.error("Please share a valid email.");
    setBusy(true);
    try { await onSubmit({ name: f.name.trim(), mobile: f.mobile.trim(), email: f.email.trim() }); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-3xl bg-white sm:max-w-md" data-testid={testId}>
        <DialogTitle className="text-2xl font-bold tracking-tight text-[#0A3A6B]">{title}</DialogTitle>
        <DialogDescription className="text-slate-600">{description}</DialogDescription>
        {children}
        <form onSubmit={submit} className="space-y-3">
          <Input placeholder="Your name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid={`${testId}-name`} />
          <Input placeholder="Mobile number" inputMode="tel" value={f.mobile} onChange={(e) => setF({ ...f, mobile: e.target.value })} data-testid={`${testId}-mobile`} />
          <Input placeholder="Email" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid={`${testId}-email`} />
          <Button type="submit" disabled={busy} className="w-full rounded-full bg-[#0A3A6B] hover:bg-[#1D64B4]" data-testid={`${testId}-submit`}>
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}{submitLabel}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
